import { useRef, useState } from "react";
import { CheckCircle2 } from "lucide-react";

const THRESHOLD = 96;
const isMobile = () => window.matchMedia("(max-width: 767px)").matches;

// Table row that, on mobile cards, can be swiped right to trigger an action.
export function SwipeTr({ enabled, onSwipe, label = "Mark paid", children, style, ...props }) {
  const start = useRef(null);
  const [dx, setDx] = useState(0);
  const [dragging, setDragging] = useState(false);

  const onTouchStart = (e) => {
    if (!enabled || !isMobile()) return;
    const t = e.touches[0];
    start.current = { x: t.clientX, y: t.clientY, axis: null };
  };
  const onTouchMove = (e) => {
    const s = start.current;
    if (!s) return;
    const t = e.touches[0];
    const mx = t.clientX - s.x, my = t.clientY - s.y;
    if (!s.axis && (Math.abs(mx) > 8 || Math.abs(my) > 8)) s.axis = Math.abs(mx) > Math.abs(my) ? "x" : "y";
    if (s.axis !== "x") return;
    setDragging(true);
    setDx(Math.max(0, Math.min(mx, 160)));
  };
  const onTouchEnd = () => {
    if (start.current && dx >= THRESHOLD) onSwipe();
    start.current = null;
    setDragging(false);
    setDx(0);
  };

  const armed = dx >= THRESHOLD;
  return (
    <tr {...props}
      onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd} onTouchCancel={onTouchEnd}
      style={{ ...style, transform: dx ? `translateX(${dx}px)` : undefined, transition: dragging ? "none" : "transform 220ms ease" }}
      className={`${props.className || ""} ${enabled ? "swipeable" : ""}`}>
      {children}
      {enabled && (
        <td aria-hidden="true" className="swipe-hint" data-armed={armed ? "1" : "0"} style={{ opacity: Math.min(dx / THRESHOLD, 1) }}>
          <CheckCircle2 className="h-5 w-5" /> {armed ? "Release" : label}
        </td>
      )}
    </tr>
  );
}
